import { setErrorReport, createReport } from "../reducers/reportReducer";
import axios, { authHeader } from "../api/HttpService";

const API_URL = process.env.REACT_APP_API_URL;

export const createReportForm = async (dispatch, reportClaim) => {
  try {
    const response = await axios.post(
      API_URL + `api/claim-property-and-liabilities`,
      reportClaim,
      {
        headers: authHeader(),
      },
    );
    dispatch(
      createReport({
        report: {
          status: response.status,
        },
      }),
    );
    return response;
  } catch (error) {
    dispatch(
      setErrorReport({
        errorReport: {
          message: error?.message || "Submission failed",
          status: error?.response?.status || null,
        },
      }),
    );
    throw error;
  }
};

export const createCertificateHolderForm = async (dispatch, formData) => {
  try {
    const response = await axios.post(
      API_URL + `api/certificates-of-insurances`,
      formData,
      {
        headers: authHeader(),
      },
    );
    dispatch(
      createReport({
        report: {
          status: response.status,
        },
      }),
    );
    return response;
  } catch (error) {
    dispatch(
      setErrorReport({
        errorReport: {
          message: error?.message || "Submission failed",
          status: error?.response?.status || null,
        },
      }),
    );
    throw error;
  }
};

export const setStatus = async (dispatch, formData) => {
  dispatch(createReport({ report: null }));
};
